import { type ReactNode } from 'react';

import { domMax, LazyMotion } from 'motion/react';

export interface MotionLazyProps {
  children: ReactNode;
}

/**
 * MotionLazy - Wrapper for Motion with lazy loading
 * Uses domMax features with tree-shaking optimization
 * Wrap your app with this component to enable the `m` component from motion/react
 */
export function MotionLazy({ children }: MotionLazyProps) {
  return (
    <LazyMotion strict features={domMax}>
      {children}
    </LazyMotion>
  );
}
